import React, { useRef, useEffect } from 'react';
import test from '../../videos/test_aero1.mp4';
import '../../styles/components/_hero.scss';
const Hero = () => {
  const videoRef = useRef(null);

  useEffect(() => {
    if (videoRef.current) {
      // Attempt to play the video programmatically
      const playPromise = videoRef.current.play();
      if (playPromise !== undefined) {
        playPromise.catch(error => {
          // Autoplay was prevented
          console.error('Autoplay prevented:', error);
        });
      }
    }
  }, []);

  return (
    <section className="hero">
      <div className="video-background">
        <video
          ref={videoRef}
          autoPlay
          loop
          muted
          playsInline
          webkit-playsinline
        >
          <source src={test} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
      <div className="hero-content">
        <h1>Innovation to explore the unknown</h1>
        <p></p>
      </div>
    </section>
  );
};

export default Hero;
